import { GolReducer } from "../types";

export default class GolEventHandler {
  private _componentName: string;
  private _reducers: Array<GolReducer>;

  constructor(
    component: string,
    observeProps: Array<string>,
    reducer: () => void
  ) {
    this._componentName = component;
    this._reducers = [
      {
        observeProps: observeProps,
        reducer: reducer,
      },
    ];
  }

  addReducer(observeProps: Array<string>, reducer: () => void) {
    this._reducers.push({ observeProps: observeProps, reducer: reducer });
  }

  set reducers(newReducers: Array<GolReducer>) {
    this._reducers = newReducers;
  }

  get reducers(): Array<GolReducer> {
    return this._reducers;
  }

  get componentName(): string {
    return this._componentName;
  }

  public dispatch = (observeProp: string) => {
    return this.reducersForObserver(observeProp).forEach((golReducer) => {
      golReducer.reducer();
    });
  };

  public reducersForObserver(observeProp: string): Array<GolReducer> {
    return this.reducers.filter((reducer) =>
      reducer.observeProps.includes(observeProp)
    );
  }
}
